<div class="clock" ng-controller="klokController">{{currentTime | date: 'HH:mm'}}</div>
